import menu from "@/constant/menu";

const menuRoutes = menu.map(item => item.children).flat();

export default menuRoutes;



// WEBPACK FOOTER //
// ./src/router/menuRoutes.js